<template>
    <div class="zindex-section">
        <div class="inset-lang">
            <a :class="[($i18n.locale == 'hk') && 'current']" @click="$i18n.locale = 'hk'">繁</a>
            <span>|</span>
            <a :class="[($i18n.locale == 'zh') && 'current']" @click="$i18n.locale = 'zh'">简</a>
        </div>
        <div class="zindex-top" :class="[($i18n.locale == 'zh') ? '' : 'zindex-top-hk']">
            <div class="index-container">
                <div class="inset-top-tips">
                    <div class="top-tips">
                        <div class="tips-top">{{$lang == 'zh' ? '「青春专享」体验卡免费领' : '「青春專享」體驗卡免費領'}}</div>
                        <dl>
                            <dt>
                                HK$
                                <big>0</big>
                                =
                            </dt>
                            <dd>
                                <ul>
                                    <li>
                                        <div class="inset-card">
                                            <span></span>
                                        </div>
                                        <p class="desc">{{$lang == 'zh' ? '手机卡' : '手機卡'}}</p>
                                    </li>
                                    <li class="add">+</li>
                                    <li>
                                        <div class="data">
                                            <big>1</big>GB
                                        </div>
                                        <p class="desc">香港<br>{{$lang == 'zh' ? '本地高速数据' : '本地高速數據'}}</p>
                                    </li>
                                    <li class="add">+</li>
                                    <li>
                                        <div class="data">
                                            <big>50</big>MB
                                        </div>
                                        <p class="desc">{{$lang == 'zh' ? '中国' : '中國'}}<br>{{$lang == 'zh' ? '内地数据' : '內地數據'}}</p>
                                    </li>
                                    <li class="add">+</li>
                                    <li>
                                        <div class="data">
                                            <big>100</big>min
                                        </div>
                                        <p class="desc">香港本地或<br>{{$lang == 'zh' ? 'IDD致电内地' : 'IDD致電內地'}}</p>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </div>
                </div>
                <div class="zindex-top-entry">
                    <ul>
                        <li @click="toFillInfo">
                            <dl>
                                <dt>
                                    <img src="../../static/images/zindex-top-entry1.png" alt="">
                                </dt>
                                <dd>
                                    <p>{{$lang == 'zh' ? '我还没有SIM卡' : '我還沒有SIM卡'}}</p>
                                    <p><strong>{{$lang == 'zh' ? '免费领取手机卡' : '免費領取手機卡'}}</strong></p>
                                </dd>
                            </dl>
                            <span class="li-arrow">
                                <img src="../../static/images/icon-next.png">
                            </span>
                        </li>
                        <li onclick="window.open('https://www.ctexcel.com.hk/toStudentEvent2019')">
                            <dl>
                                <dt>
                                    <img src="../../static/images/zindex-top-entry2.png" alt="">
                                </dt>
                                <dd>
                                    <p>{{$lang == 'zh' ? '体验卡详情' : '體驗卡詳情'}}</p>
                                    <p><strong>{{$lang == 'zh' ? '查看2019学生体验卡' : '查看2019學生體驗卡'}}</strong></p>
                                </dd>
                            </dl>
                            <span class="li-arrow">
                                <img src="../../static/images/icon-next.png">
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="zindex-discount">
            <div class="index-container">
                <div class="zindex-title">
                    <p class="t">{{$lang == 'zh' ? '「校园棒棒糖」计划' : '「校園棒棒糖」計劃'}} <big>{{$lang == 'zh' ? '专属优惠' : '專屬優惠'}}</big></p>
                    <p class="sub">
                        <span>{{$lang == 'zh' ? '12个月/24个月' : '12個月/24個月'}}</span>
                    </p>
                </div>
                <ul>
                    <li>
                        <dl>
                            <dt>免</dt>
                            <dd>
                                <p>{{$lang == 'zh' ? '行政费' : '行政費'}}</p>
                                <p>HK$ 18/月</p>
                            </dd>
                        </dl>
                    </li>
                    <li>
                        <dl>
                            <dt>免</dt>
                            <dd>
                                <p>{{$lang == 'zh' ? '中国内地流动' : '中國內地流動'}}<br>{{$lang == 'zh' ? '电话号码月费' : '電話號碼月費'}}</p>
                                <p>HK$ 18/月</p>
                            </dd>
                        </dl>
                    </li>
                    <li>
                        <dl>
                            <dt>送</dt>
                            <dd>
                                <p>{{$lang == 'zh' ? '每月2日中国内地' : '每月2日中國內地'}}<br>{{$lang == 'zh' ? '「数据漫游Day Pass」' : '「數據漫遊Day Pass」'}}</p>
                                <p>HK$ 48/日</p>
                            </dd>
                        </dl>
                    </li>
                    <li>
                        <dl>
                            <dt>送</dt>
                            <dd>
                                <p>{{$lang == 'zh' ? '特惠IDD致电' : '特惠IDD致電'}}<br>{{$lang == 'zh' ? '中国内地: 100分钟' : '中國內地: 100分鐘'}}</p>
                                <p>HK$ 18/月</p>
                            </dd>
                        </dl>
                    </li>
                </ul>
                <p class="discount-tips"><span></span>{{$lang == 'zh' ? '活动推广期：由即日起至2019年12月31日' : '活動推廣期：由即日起至2019年12月31日'}}</p>
            </div>
        </div>
        <div class="zindex-planlist">
            <div class="index-container">
                <div class="zindex-title">
                    <p class="t">{{$lang == 'zh' ? '「校园棒棒糖」计划' : '「校園棒棒糖」計劃'}} <big>{{$lang == 'zh' ? '月费详情' : '月費詳情'}}</big></p>
                </div>
                <div class="planlist-cont">
                    <ul>
                        <li>
                            <div class="li-top">
                                <p class="level">
                                    <span>{{$lang == 'zh' ? '少糖级' : '少糖級'}}</span>
                                </p>
                                <p class="price">HK$ <big>{{planList1 == 299 ? 700 : 68}}</big></p>
                                <p class="old-price">{{$lang == 'zh' ? '原价' : '原價'}}：HK$ {{planList1 == 299 ? 816 : 78}}</p>
                                <p class="data">5GB</p>
                            </div>
                            <div class="li-cont">
                                <p>{{$lang == 'zh' ? '合约期' : '合約期'}}:
                                    <select v-model="planList1">
                                        <option value="279">24 {{$lang == 'zh' ? '个月' : '個月'}}</option>
                                        <option value="276">12 {{$lang == 'zh' ? '个月' : '個月'}}</option>
                                        <option value="299">{{$lang == 'zh' ? '年付早鸟优惠' : '年付早鳥優惠'}}</option>
                                    </select>
                                </p>
                                <p>{{$lang == 'zh' ? '香港本地通话' : '香港本地通話'}}<span>1000{{$lang == 'zh' ? '分钟' : '分鐘'}}</span></p>
                                <p>{{$lang == 'zh' ? '香港本地数据' : '香港本地數據'}}（4G LTE）<span>5GB</span>+{{$lang == 'zh' ? '其后无限' : '其後無限'}}</p>
                            </div>
                            <div class="li-tips">
                                <span v-show="planList1 == 279">{{$lang == 'zh' ? '全年送流动服务奖赏' : '全年送流動服務獎賞'}} HK$ 200</span>
                            </div>
                            <div class="li-button">
                                <a  :href="$store.state.param.activeUrl + planList1" target="_blank">{{$lang == 'zh' ? '立即订购' : '立即訂購'}}</a>
                            </div>
                        </li>
                        <li>
                            <div class="li-top">
                                <p class="level">
                                    <span>{{$lang == 'zh' ? '半糖级' : '半糖級'}}</span>
                                </p>
                                <p class="price">HK$ <big>{{planList2 == 300 ? 1300 : 128}}</big></p>
                                <p class="old-price">{{$lang == 'zh' ? '原价' : '原價'}}：HK$ {{planList2 == 1536 ? 816 : 148}}</p>
                                <p class="data">10GB</p>
                            </div>
                            <div class="li-cont">
                                <p>{{$lang == 'zh' ? '合约期' : '合約期'}}:
                                    <select v-model="planList2">
                                        <option value="280">24 {{$lang == 'zh' ? '个月' : '個月'}}</option>
                                        <option value="277">12 {{$lang == 'zh' ? '个月' : '個月'}}</option>
                                        <option value="300">{{$lang == 'zh' ? '年付早鸟优惠' : '年付早鳥優惠'}}</option>
                                    </select>
                                </p>
                                <p><span>{{$lang == 'zh' ? '无限' : '無限'}}</span>{{$lang == 'zh' ? '香港本地通话' : '香港本地通話'}}</p>
                                <p>{{$lang == 'zh' ? '香港本地数据' : '香港本地數據'}}（4G LTE）<span>10GB</span>+{{$lang == 'zh' ? '其后无限' : '其後無限'}}</p>
                            </div>
                            <div class="li-tips">
                                <span v-show="planList2 == 280">{{$lang == 'zh' ? '全年送流动服务特赏' : '全年送流動服務獎賞'}} HK$ 300</span>
                            </div>
                            <div class="li-button">
                                <a :href="$store.state.param.activeUrl + planList2" target="_blank">{{$lang == 'zh' ? '立即订购' : '立即訂購'}}</a>
                            </div>
                        </li>
                        <li>
                            <div class="li-top">
                                <p class="level">
                                    <span>{{$lang == 'zh' ? '全糖级' : '全糖級'}}</span>
                                </p>
                                <p class="price">HK$ <big>{{planList3 == 300 ? 2000 : 208}}</big></p>
                                <p class="old-price">{{$lang == 'zh' ? '原价' : '原價'}}：HK$ {{planList3 == 2496 ? 816 : 248}}</p>
                                <p class="data">20GB</p>
                            </div>
                            <div class="li-cont">
                                <p>{{$lang == 'zh' ? '合约期' : '合約期'}}:
                                    <select v-model="planList3">
                                        <option value="281">24 {{$lang == 'zh' ? '个月' : '個月'}}</option>
                                        <option value="278">12 {{$lang == 'zh' ? '个月' : '個月'}}</option>
                                        <option value="301">{{$lang == 'zh' ? '年付早鸟优惠' : '年付早鳥優惠'}}</option>
                                    </select>
                                </p>
                                <p><span>{{$lang == 'zh' ? '无限' : '無限'}}</span>{{$lang == 'zh' ? '香港本地通话' : '香港本地通話'}}</p>
                                <p>{{$lang == 'zh' ? '香港本地数据' : '香港本地數據'}}（4G LTE）<span>20GB</span>+{{$lang == 'zh' ? '其后无限' : '其後無限'}}</p>
                            </div>
                            <div class="li-tips">
                                <span v-show="planList3 == 281">{{$lang == 'zh' ? '全年送流动服务特赏' : '全年送流動服務獎賞'}} HK$ 400</span>
                            </div>
                            <div class="li-button">
                                <a :href="$store.state.param.activeUrl + planList3" target="_blank">{{$lang == 'zh' ? '立即订购' : '立即訂購'}}</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="zindex-ebird">
            <div class="index-container">
                <div class="zindex-title">
                    <p class="t">{{$lang == 'zh' ? '「校园棒棒糖」计划' : '「校園棒棒糖」計劃'}} <big>{{$lang == 'zh' ? '早鸟优惠' : '早鳥優惠'}}</big></p>
                    <p class="sub">
                        <span>{{$lang == 'zh' ? '合约期12个月 一次性付款' : '合約期12個月 一次性付款'}}</span>
                    </p>
                </div>
                <div class="ebird-content">
                    <div class="ebird-tips">
                        <span>{{$lang == 'zh' ? '震撼' : '震撼'}}<br>{{$lang == 'zh' ? '优惠' : '優惠'}}</span>
                    </div>
                    <ul>
                        <li>
                            <dl>
                                <dt>少糖{{$lang == 'zh' ? '级' : '級'}}</dt>
                                <dd>
                                    <div>
                                        <del>{{$lang == 'zh' ? '原价' : '原價'}}：$68 x 12 = $816</del>
                                    </div>
                                    <div style="cursor:pointer" @click="toBundle(299)">
                                        {{$lang == 'zh' ? '年付优惠价' : '年付優惠價'}}  HK$<big>700</big><small style="font-size: 14px">({{$lang == 'zh' ? '按此订购' : '按此訂購'}})</small>
                                        <p style="font-size: 14px;color: #0390e7; text-align: center">（{{$lang == 'zh' ? '平均月费' : '平均月費'}}：HK$58）</p>
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        <li>
                            <dl>
                                <dt>半糖{{$lang == 'zh' ? '级' : '級'}}</dt>
                                <dd>
                                    <div>
                                        <del>{{$lang == 'zh' ? '原价' : '原價'}}：$128 x 12 = $1,536</del>
                                    </div>
                                    <div style="cursor:pointer"  @click="toBundle(300)">
                                        {{$lang == 'zh' ? '年付优惠价' : '年付優惠價'}}  HK$<big>1,300</big><small style="font-size: 14px">({{$lang == 'zh' ? '按此订购' : '按此訂購'}})</small>
                                        <p style="font-size: 14px;color: #0390e7; text-align: center">（{{$lang == 'zh' ? '平均月费' : '平均月費'}}：HK$108）</p>
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        <li>
                            <dl>
                                <dt>全糖{{$lang == 'zh' ? '级' : '級'}}</dt>
                                <dd>
                                    <div>
                                        <del>{{$lang == 'zh' ? '原价' : '原價'}}：$208 x 12 = $2,496</del>
                                    </div>
                                    <div style="cursor:pointer"  @click="toBundle(301)">
                                        {{$lang == 'zh' ? '年付优惠价' : '年付優惠價'}}  HK$<big>2,000</big><small style="font-size: 14px">({{$lang == 'zh' ? '按此订购' : '按此訂購'}})</small>
                                        <p style="font-size: 14px;color: #0390e7; text-align: center">（{{$lang == 'zh' ? '平均月费' : '平均月費'}}：HK$167）</p>
                                    </div>
                                </dd>
                            </dl>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="forward-box">
            <div class="forward-list">
                <ul>
                    <li style="position: relative;height: auto;">
                        <div class="li-left">
                            <div>
                                <p>{{$lang == 'zh' ? '转换' : '轉換'}}</p>
                                <p>{{$lang == 'zh' ? '「校园棒棒糖」计划教程' : '「校園棒棒糖」計劃教程'}}</p>
                            </div>
                        </div>
                        <div class="li-middle" style="padding-top: 15px;padding-bottom: 15px;">
                            <div>
                                <!-- <p><small>{{$lang == 'zh' ? '学生体验卡转换「校园棒棒糖」计划' : '學生體驗卡轉換「校園棒棒糖」計劃'}}</small></p> -->
                                <dl>
                                    <dd><span style="color: #fa80bf">●</span> {{$lang == 'zh' ? '免行政费' : '免行政費'}} <span style="color: #fa80bf">HK$ 18/月</span></dd>
                                    <dd><span style="color: #fa80bf">●</span> {{$lang == 'zh' ? '免一卡多号月费' : '免一卡多號月費'}}  <span style="color: #fa80bf">HK$ 18/月</span></dd>
                                    <dd><span style="color: #fa80bf">●</span> {{$lang == 'zh' ? '送每月2日中国内地「数据漫游」' : '送每月2日中國內地「數據漫遊」'}}<br>Day Pass   <span style="color: #fa80bf">HK$ 48/月</span></dd>
                                    <dd><span style="color: #fa80bf">●</span> {{$lang == 'zh' ? '送特惠IDD致电中国内地' : '送特惠IDD致電中國內地'}}:  <span style="color: #fa80bf">100{{$lang == 'zh' ? '分钟' : '分鐘'}}  HK$ 18/月</span></dd>
                                </dl>
                            </div>
                        </div>
                        <div class="li-right" style="position: absolute;right: 0;top: 50%;transform: translateY(-50%)">
                            <a @click="showStudy = true">{{$lang == 'zh' ? '查看教程' : '查看教程'}}</a>
                        </div>
                    </li>
                    <li>
                        <div class="li-left">
                            <div>
                                <p>{{$lang == 'zh' ? '「大流量服务组合」' : '「大流量服務組合」'}}</p>
                                <p><small><span>({{$lang == 'zh' ? '学生体验卡专享' : '學生體驗卡專享'}})</span></small></p>
                            </div>
                        </div>
                        <div class="li-middle">
                            <div>
                                <p><small>{{$lang == 'zh' ? '优惠价' : '優惠價'}}</small> <strong>HK$ 198/HK$ 358</strong></p>
                                <dl>
                                    <dd>香港本地流量  10/20GB</dd>
                                    <dd>{{$lang == 'zh' ? '香港本地通话' : '香港本地通話'}}  1000/1500{{$lang == 'zh' ? '分钟' : '分鐘'}}</dd>
                                    <dd>{{$lang == 'zh' ? '致电中国内地' : '致電中国内地'}}  100/200{{$lang == 'zh' ? '分钟' : '分鐘'}}</dd>
                                </dl>
                            </div>
                        </div>
                        <div class="li-right">
                            <a @click="showOrder = true">{{$lang == 'zh' ? '查看订购方式' : '查看訂購方式'}}</a>
                        </div>
                    </li>
                    <li>
                        <div class="li-left">
                            <div>
                                <p>「{{$lang == 'zh' ? '赏你赏他' : '賞你賞他'}}」</p>
                                <p><small>{{$lang == 'zh' ? '推荐奖赏' : '推薦獎賞'}}</small></p>
                            </div>
                        </div>
                        <div class="li-middle">
                            <div>
                                <p>{{$lang == 'zh' ? '现有客户推荐一位朋友成功上台' : '現有客戶推薦一位朋友成功上台'}}
                                （「{{$lang == 'zh' ? '校园棒棒糖」计划' : '校園棒棒糖」計劃'}}）</p>
                                <p>{{$lang == 'zh' ? '即「赏」你' : '即「賞」你'}} <strong>6GB{{$lang == 'zh' ? '数据' : '數據，'}}</strong></p>
                                <p>{{$lang == 'zh' ? '同时「赏」他' : '同時「賞」他'}} <strong>6GB{{$lang == 'zh' ? '数据' : '數據'}}!</strong></p>
                            </div>
                        </div>
                        <div class="li-right">
                            <a @click="showAppYour = true">{{$lang == 'zh' ? '查看详情' : '查看詳情'}}</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer-dv">
            *{{$lang == 'zh' ? '活动最终解释权归中国电信国际有限公司所有' : '活動最終解釋權歸中國電信國際有限公司所有'}}
        </div>
        <server-order :showOrder = "showOrder" @changeOrder="changeOrder"></server-order>
        <app-your :showOrder = "showAppYour" @changeOrder = "changeAppYour"></app-your>
        <study-step :showOrder = "showStudy" @changeOrder = "changeStudy"></study-step>
    </div>
    
</template>

<script>
    import serverOrder from '@/components/serverOrder'
    import appYour from '@/components/appYour'
    import studyStep from '@/components/studyStep'
    export default {
        components: {
            serverOrder,
            appYour,
            studyStep
        },
        data () {
            return {
                planList1: "276",
                planList2: "277",
                planList3: "278",
                showOrder: false,
                showAppYour: false,
                showStudy: false,
            }
        },
        computed: {
            $lang () {
                return this.$i18n.locale == "zh" ? 'zh' : 'hk';
            }
        },
        methods: {
            toBundle (bundleId) {
                console.log(this.$store)
                let url = this.$store.state.param.activeUrl + bundleId;
                location.href = url
            },
            toFillInfo () {
                // this.indexMark('100');
                this.$router.push({
                    path: '/fillInfo'
                })
            },
            changeOrder (val) {
                this.showOrder = val
            },
            changeAppYour (val) {
                this.showAppYour = val
            },
            changeStudy (val) {
                console.log('changeStudy')
                this.showStudy = val
            }
        }
    }
</script>

<style scoped lang="less">

</style>


// WEBPACK FOOTER //
// src/pages/newIndex.vue